<template>
  <b-overlay :show="apiRslt.fetch.inProgress" rounded="sm" opacity="0.5" blur="none">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <!------Nom------->
          <div class="col-md-6 my-2">
            <text-field
                name="Nom du produit"
                property="name"
                v-model="$v.form.name.$model"
                :error="$v.form.name.$error"
                :isRequired="checkIfRequired($v.form.name)"
                errorCode="MESS001"
            />
          </div>
          <!------Stickers------->
          <div class="col-md-6 my-2">
            <select-field
                v-model="$v.form.sticker.$model"
                property="sticker"
                name="Sticker"
                :options="stickersSelect"
                :error="$v.form.sticker.$error"
                :isRequired="checkIfRequired($v.form.sticker)"
                errorCode="MESS004"
            />
          </div>

          <!------Price------->
          <div class="col-md-4 my-2">
            <price-field
                name="Prix"
                property="sectionPrice"
                v-model.number="$v.form.price.$model"
                :error="$v.form.price.$error"
                :disabled="true"
                errorCode="MESS005"
            />
          </div>
          <!------Price------->
          <div class="col-md-4 my-2">
            <price-field
                name="Prix HT"
                property="price_ht"
                v-model.number="$v.form.price_ht.$model"
                :error="$v.form.price_ht.$error"
                :isRequired="checkIfRequired($v.form.price_ht)"
                errorCode="MESS005"
            />
          </div>
          <!------TVA------->
          <div class="col-md-4 mt-2">
            <price-field
                name="TVA"
                property="tva"
                v-model.number="$v.form.tva.$model"
                :error="$v.form.tva.$error"
                prefix="%"
                class="mb-0"
                :isRequired="checkIfRequired($v.form.tva)"
                errorCode="MESS003"
            />
          </div>
          <div v-if="form.tva" class="col-md-12 mt-0 mb-2">
            <button type="button" class="btn btn-success" @click="calculTVA">Calculer le prix</button>
          </div>
          <comma-caution/>

          <!------Catégorie------->
          <div class="col-md-6 my-2">
            <select-field
                v-model="$v.form.category.$model"
                property="category"
                name="Catégorie"
                :options="categoriesSelect"
                :error="$v.form.category.$error"
                :disabled="form.sousCategory !== null"
                :isRequired="checkIfRequired($v.form.category)"
                errorCode="MESS004"
            />
          </div>
          <!------Sous-catégorie------->
          <div class="col-md-6 my-2">
            <select-field
                v-model="$v.form.sousCategory.$model"
                property="sousCategory"
                name="Sous-catégorie"
                :options="sousCategorieSelect"
                :error="$v.form.sousCategory.$error"
                :disabled="form.category !== null"
                :isRequired="checkIfRequired($v.form.sousCategory)"
                errorCode="MESS004"
            />
          </div>

          <!------Disponible point de vente------->
          <small class="text-secondary"> Disponibilités points de vente <span class="text-danger" v-if="checkIfRequired($v.form.availablePdv)">*</span> </small>
          <b-form-checkbox-group
              id="outlets"
              class="my-2"
              v-model="$v.form.availablePdv.$model"
              :options="outlets"
              value-field="denomination"
              text-field="name"
              :class="{'is-invalid': $v.form.availablePdv.$error  }"
          ></b-form-checkbox-group>
        </div>
      </div>
      <!------Photo------->
      <div class="col-12">
        <div class="row">
          <preview-field :imageIn="form.image" :folder="product_url" />
        </div>
        <div class="row">
          <file-field 
              v-model="form.image" 
              :isRequired="true" 
              name="Photo produit" 
              errorCode="MESS006"
              :error="$v.form.image.$error"
           />
        </div>
      </div>
      
      <!------Description------->
      <div class="col-md-12">
        <div class="row">
          
          <div class="col-md-12 my-2">
            <textarea-field
                name="Description"
                property="description"
                length="90"
                v-model="$v.form.description.$model"
                :error="$v.form.description.$error"
                :isRequired="checkIfRequired($v.form.description)"
                errorCode="MESS007"
            />
          </div>
        </div>
      </div>
      <div class="col-md-12 mt-4">
        <button id="btn-crud-add" class="btn btn-primary float-right" v-show="operation==='add'" style="border-radius: 0;" @click="added">Ajouter</button>
        <button id="btn-crud-update" class="btn btn-primary float-right" v-show="operation==='update'" style="border-radius: 0;" @click="updated">Modifier</button>
        <button id="btn-crud-remove" class="btn float-left bg-danger text-white" v-show="operation==='update'" style="border-radius: 0;" @click="deleted">Supprimer</button>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import {required, minLength, requiredIf } from 'vuelidate/lib/validators'
import {mapActions, mapState} from "vuex";
import {PriceField, SelectField, TextareaField, TextField, FileField, PreviewField } from "@/core/components/form";
import CommaCaution from "@/core/components/common/CommaCaution";
import {form, init} from "@/core/mixins";

export default {
  name: 'FormProduct',
  components:{ TextField, SelectField, TextareaField, PriceField, PreviewField, FileField, CommaCaution },
  mixins:[form,init],
  computed: {
    ...mapState('categories', ['categories','categoriesSelect','sousCategorieSelect']),
    ...mapState('products',['apiRslt']),
    ...mapState('outlets', ['outlets']),
  },
  data() {
    return {
      form: {
        sousCategory: null,
        category: null,
        description: '',
        name: '',
        sticker:'',
        price: 0,
        price_ht: 0,
        tva:0,
        isAvailable: true,
        image: '',
        availablePdv: []
      },
      init: {
        sousCategory: null,
        category: null,
        description: '',
        name: '',
        sticker:'',
        price: 0,
        price_ht: 0,
        tva:0,
        isAvailable: true,
        image: '',
        availablePdv: []
      },
      stickersSelect:[
        {text:'Étiquette Asie', value: 'etiquettes_asie.png'},
        {text:'Étiquette Inde', value: 'etiquettes_inde.png'},
        {text:'Étiquette Liban', value: 'etiquettes_liban.png'},
        {text:'Étiquette Martinique', value: 'etiquettes_martinique.png'},
        {text:'Étiquette Mexique', value: 'etiquettes_mexique.png'},
        {text:'Étiquette Norvège', value: 'etiquettes_norvege.png'}
      ]
    }
  },
  watch:{
    'form.price_ht'(newval){
      if(this.form.tva <= 0){
        this.form.price = newval
      }
    }
  },
  methods: {
    ...mapActions('products', ['addProduct', 'updateProduct', 'deleteProduct']),
    added(){
      this.$v.form.$reset()
      this.$v.form.$touch()
      if(!this.$v.form.$error) this.addProduct(this.form)
    },
    updated(){
      this.$v.form.$reset()
      this.$v.form.$touch()
      if(!this.$v.form.$error) this.updateProduct(this.form)
    },
    deleted(){
      this.deleteProduct(this.form.id)
      this.reset(this.form.id)
    },
    calculTVA(){
      if(this.form.price_ht > 0){
        const tva = (this.form.price_ht * (this.form.tva/100).toFixed(3)).toFixed(2)
        this.form.price = Number.parseFloat(this.form.price_ht) + Number.parseFloat(tva)
      }
    }
  },
  validations() {
    return {
      form:{
          category: { requiredIf: requiredIf(()=>{
            return this.form.sousCategory === null
            }) },
          description: { required },
          sticker: {},
          name: { required, min: minLength(1) },
          price: {  },
          price_ht:{  },
          tva:{  },
          sousCategory: { requiredIf: requiredIf(()=>{
              return this.form.category === null
          })},
          isAvailable: { required },
          availablePdv: { required },
          image: { requiredIf: requiredIf( () => {
              return this.form.image instanceof File || typeof this.form.image === 'string'
            }) }
        },
    }
  },
}
</script>

<style scoped>
  .btn:hover:not(.btn-icon-only) {
    box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
    transform: translateY(-1px);
  }
  .btn-primary {
    color: #000;
    background-color: #5e72e4 !important;
    border-color: #5e72e4 !important;
    color: white !important;
  }
  .btn {
    border-radius: 0.5rem;
  }
</style>
